async function getDataToFilterBusiness() {
  const responsePromise = await fetch('/businessAmount.json');

  return await responsePromise.json();
}

export default getDataToFilterBusiness;
